<template>
  <common-page-edit
    :title="title"
    :nameRoleEntity="nameRoleEntity"
    :apiNameGet="apiNameGet"
    
    :routeNameShow="routeNameShow"
    :routeNameCreate="routeNameCreate"
    :keyRoute="'id'"
    :backUrl="pathBack"
    @set-loadData="setLoadData"
    :convertLoadData="convertLoadData"
    :paramsSave="paramsSave"
    :isDefaultConverter="false"
    :paramsSend="paramsSend"
    :forceNoShowEdit="true"
    :showHistoryFunction="showHistoryFunction"
    
    :showHistory="false"
  >
  </common-page-edit>
</template>
<script>
import { API_METHODS, FIELD_LANG_COMPANY } from "../../../../constant";
import { NAME_OBJECT } from "../../../../RoleConstanans";
import CommonPageEdit from "../../commonElement/CommonPageEdit.vue";
import CompanyData from "../company/CompanyData.vue";

import convertFieldInfoListToScheme from "../../../../helpers/converters/convetFieldInfoListToScheme";

export default {
  name: "HrFeedLogEditPageDynamic",
  components: {
    CommonPageEdit,
    CompanyData
  },
  data() {
    return {
      wait: false,
      scheme: {},
      loadData: null,
      fieldInfoList: null,
      preResult: null,
      load: true,

      routeNameShow: "HrFeedLogEditPageDynamicShow",
      routeNameCreate: "AgreementsCreate2",

      apiNameGet: API_METHODS.GET_HR_LOG,
      loadData: null,


    };
  },
  computed: {
    pathBack() {
      return `/company/client/${this.$route.params.CompanyId}/edit`;
    },
    title() {
      let text1 = this.$t("Просмотр hrlog");
      let text2 = this.$t("Создание соглашения");
      let text3 = this.$t("Редактирование соглашения");

      let findShow = this.$route.path.indexOf("show");
      if (findShow != -1) {
        return text1;
      }
      let findCreate = this.$route.path.indexOf("create");
      if (findCreate != -1) {
        return text2;
      }
      let findEdit = this.$route.path.indexOf("edit");
      if (findEdit != -1) {
        return text3;
      }
      return text1;
    },
    nameRoleEntity() {
      return NAME_OBJECT.clients;
    },
    paramsSend() {
      return {
        SubjectId: this.$route.params.CompanyId || "0",
        LogId: this.$route.params.id || "0",
      };
    },
  },

  methods: {
    convertLoadData(res) {
      let loadData = res.object;
      let fieldInfoList = res.fieldInfoList;
      let scheme = { configForm: [] };

      scheme.configForm = convertFieldInfoListToScheme({
        fieldInfoList,
        langFieldName: FIELD_LANG_COMPANY,
          hasLang: false
      });

      return {
        loadData,
        fieldInfoList,
        scheme
      };
    },
    showHistoryFunction() {

    },
    setLoadData(loadData) {
      this.loadData = loadData;
    },

    paramsSave() {
      return {
        id: this.$route.params.CompanyId,
      };
    }
  }
};
</script>
